import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { Container } from "../ui/Container";
import { Logo } from "../ui/Logo";
import { colors, media, fonts } from "../../theme";

const socials = [
  { name: "Twitter", href: "https://twitter.com/everpesa_app/", icon: TwitterIcon },
  { name: "LinkedIn", href: "https://www.linkedin.com/company/everpesa/", icon: LinkedInIcon },
  { name: "Instagram", href: "https://www.instagram.com/everpesa/", icon: InstagramIcon },
  { name: "Facebook", href: "https://www.facebook.com/profile.php?id=100092325456479", icon: FacebookIcon },
  { name: "YouTube", href: "https://www.youtube.com/@everpesa", icon: YouTubeIcon },
  { name: "TikTok", href: "https://tiktok.com/@everpesa", icon: TikTokIcon },
];

export const Footer = () => (
  <Wrap>
    <Container>
      <Top>
        <Brand>
          <Logo light />
          <Tag>
            Affordable digital credit that powers small business growth.
            Peer to peer lending marketplace built in Kampala, Uganda.
          </Tag>
          <Licensed>
            <span>•</span> Licensed Money Lender. Uganda Microfinance Regulatory Authority.
          </Licensed>

          <Socials>
            {socials.map(({ name, href, icon: Icon }) => (
              <SocialLink
                key={name}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={name}
              >
                <Icon />
              </SocialLink>
            ))}
          </Socials>
        </Brand>

        <Cols>
          <Col>
            <h4>Platform</h4>
            <Link to="/invest">For investors</Link>
            <Link to="/borrow">For small businesses</Link>
            <a href="https://invest.everpesa.com" target="_blank" rel="noopener noreferrer">
              Sign in
            </a>
            <a href="https://invest.everpesa.com" target="_blank" rel="noopener noreferrer">
              Open account
            </a>
          </Col>
          <Col>
            <h4>Products</h4>
            <Link to="/products#sacco">SACCO Core Banking</Link>
            <Link to="/products#supplychain">Supply Chain Finance</Link>
            <Link to="/products#grain">Grain Voucher System</Link>
            <Link to="/products#bnpl">Ed Tech BNPL</Link>
            <Link to="/software">Software and ICT</Link>
          </Col>
          <Col>
            <h4>Company</h4>
            <Link to="/about">About</Link>
            <Link to="/about#team">Team</Link>
            <Link to="/contact">Contact</Link>
            <a href="mailto:sales@everpesa.com">Invest in Everpesa</a>
          </Col>
          <Col>
            <h4>Find us</h4>
            <Address>
              National ICT Innovation Hub<br />
              Plot 19 to 21 Portbell Road, Nakawa<br />
              Kampala, Uganda
            </Address>
            <a href="tel:+256786493685">+256 786 493 685</a>
            <a href="tel:+256770703204">+256 776 431 680</a>
            <a href="mailto:info@everpesa.com">info@everpesa.com</a>
            <a href="mailto:sales@everpesa.com">sales@everpesa.com</a>
          </Col>
        </Cols>
      </Top>

      <Legal>
        <Link to="/terms">Terms of Service</Link>
        <Link to="/privacy">Privacy Policy</Link>
        <Link to="/compliance">Compliance</Link>
      </Legal>

      <Bottom>
        <small>© {new Date().getFullYear()} Everpesa Technologies Ltd. All rights reserved.</small>
        <small>
          Everpesa Technologies Ltd is a financial technology and software company
          and is not a bank. Banking services are provided by partner institutions.
        </small>
      </Bottom>
    </Container>
  </Wrap>
);

function TwitterIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  );
}
function LinkedInIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
    </svg>
  );
}
function InstagramIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
    </svg>
  );
}
function FacebookIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z" />
    </svg>
  );
}
function YouTubeIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z" />
    </svg>
  );
}
function TikTokIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.71A8.16 8.16 0 0 0 21.6 10.7V7.27a4.85 4.85 0 0 1-2.01-.58z" />
    </svg>
  );
}

const Wrap = styled.footer`
  background: ${colors.brandDeep};
  color: rgba(255,255,255,0.78);
  padding: 80px 0 32px;
  font-family: ${fonts.body};

  ${media.md} { padding: 56px 0 28px; }
`;

const Top = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 2.8fr;
  gap: 64px;
  padding-bottom: 56px;
  border-bottom: 1px solid rgba(255,255,255,0.08);

  ${media.md} {
    grid-template-columns: 1fr;
    gap: 40px;
    padding-bottom: 40px;
  }
`;

const Brand = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  max-width: 360px;
`;

const Tag = styled.p`
  color: rgba(255,255,255,0.7);
  font-size: 14.5px;
  line-height: 1.65;
`;

const Licensed = styled.span`
  display: inline-flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 12.5px;
  color: rgba(255,255,255,0.55);
  span { color: ${colors.gold}; font-size: 18px; line-height: 1; }
`;

const Socials = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 8px;
`;

const SocialLink = styled.a`
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(255,255,255,0.06);
  border: 1px solid rgba(255,255,255,0.1);
  color: rgba(255,255,255,0.78);
  transition: background 200ms ease, color 200ms ease, border-color 200ms ease, transform 200ms ease;

  &:hover {
    background: ${colors.brand};
    color: white;
    border-color: ${colors.brand};
    transform: translateY(-2px);
  }
`;

const Cols = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 32px;

  ${media.md} {
    grid-template-columns: repeat(2, 1fr);
    gap: 32px 24px;
  }
`;

const Col = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  h4 {
    color: white;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    margin-bottom: 10px;
    font-family: ${fonts.body};
  }

  a {
    color: rgba(255,255,255,0.65);
    font-size: 14px;
    transition: color 180ms ease;
    &:hover { color: white; }
  }
`;

const Address = styled.address`
  color: rgba(255,255,255,0.65);
  font-style: normal;
  font-size: 14px;
  line-height: 1.7;
`;

const Legal = styled.div`
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  padding: 24px 0;
  border-bottom: 1px solid rgba(255,255,255,0.08);

  a {
    color: rgba(255,255,255,0.55);
    font-size: 13px;
    &:hover { color: white; }
  }
`;

const Bottom = styled.div`
  margin-top: 24px;
  display: flex;
  justify-content: space-between;
  gap: 24px;
  flex-wrap: wrap;

  small {
    color: rgba(255,255,255,0.5);
    font-size: 12.5px;
    max-width: 540px;
    line-height: 1.6;
  }
`;
